import React, { SVGProps } from 'react';

/**
 * Agents Icon Component (Migrated from chariot-ui)
 *
 * Migration reason: Missing stroke styling in shared library caused icon to be invisible
 * in navigation sidebar. Local version needed to properly support light/dark modes.
 *
 * Original: chariot-ui/Agents
 * Migrated: 2025-10-22
 *
 * Changes from original:
 * - Added proper stroke classes for light/dark mode support
 * - Updated to use Chariot design system color variables
 * - Added consistent className prop spreading for flexibility
 *
 * @example
 * ```tsx
 * <AgentsIcon className="size-5" />
 * ```
 */
export const AgentsIcon: React.FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M2.5 9.16669H5C5.44203 9.16669 5.86595 9.34228 6.17851 9.65484C6.49107 9.9674 6.66667 10.3913 6.66667 10.8334V13.3334C6.66667 13.7754 6.49107 14.1993 6.17851 14.5119C5.86595 14.8244 5.44203 15 5 15H4.16667C3.72464 15 3.30072 14.8244 2.98816 14.5119C2.67559 14.1993 2.5 13.7754 2.5 13.3334V9.16669ZM2.5 9.16669C2.5 8.18177 2.69399 7.2065 3.0709 6.29656C3.44781 5.38662 4.00026 4.55983 4.6967 3.86339C5.39314 3.16695 6.21993 2.6145 7.12987 2.23759C8.03982 1.86068 9.01509 1.66669 10 1.66669C10.9849 1.66669 11.9602 1.86068 12.8701 2.23759C13.7801 2.6145 14.6069 3.16695 15.3033 3.86339C15.9997 4.55983 16.5522 5.38662 16.9291 6.29656C17.306 7.2065 17.5 8.18177 17.5 9.16669M17.5 9.16669V13.3334C17.5 13.7754 17.3244 14.1993 17.0118 14.5119C16.6993 14.8244 16.2754 15 15.8333 15H15C14.558 15 14.134 14.8244 13.8215 14.5119C13.5089 14.1993 13.3333 13.7754 13.3333 13.3334V10.8334C13.3333 10.3913 13.5089 9.9674 13.8215 9.65484C14.134 9.34228 14.558 9.16669 15 9.16669H17.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 13.3333V15C17.5 15.884 17.1488 16.7319 16.5237 17.357C15.8986 17.9821 15.0507 18.3333 14.1667 18.3333H10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
